exports = module.exports = require("../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-divider[data-v-e3487434] {\n  margin-top: 0;\n  margin-bottom: 8px;\n}", ""]);

// exports
